import { Component } from "react"
import PropTypes from "prop-types"
import _map from "lodash/map"

export default class EndpointTestAssertions extends Component {
  render() {
    const assertions = _map(this.props.assertions, (assertion, slug) => {
      return (
        <div
          className={`publish-item assertion ${assertion.status || ""}`}
          key={`assertion-${assertion.slug || slug}`}
        >
          <header>{assertion.label}</header>
        </div>
      )
    })
    return (
      <section className="assertions test-case-detail">
        <h6>Checklist</h6>
        {assertions}
      </section>
    )
  }
}

EndpointTestAssertions.propTypes = {
  assertions: PropTypes.object.isRequired,
}
